export class GetAWSStackDetailsResponse {
    'region';
    'stackId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "stackId",
            "baseName": "stackId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetAWSStackDetailsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
